define('views/components/lead_note/lead_note_list',['require','views/base/list_view','views/components/lead_note/lead_note','text!templates/components/lead_note/lead_note_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/lead_note/lead_note');

    var temp = require("text!templates/components/lead_note/lead_note_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

